@if (prodCode$ | async; as prodCode) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: prodCode }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: prodCode }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <div class="flex layout-col">
      <elder-basic-pane-layout class="full">
        <elder-pane>
          <elder-pane-header>
            <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
            <elder-pane-actions>
              <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
                  <mat-icon>delete</mat-icon>
                  <span>{{ 'actions.delete' | translate }}</span>
                </button>
              </mat-menu>
            </elder-pane-actions>
          </elder-pane-header>
          <elder-pane-content>
            <form #mainFrm="ngForm" class="flex layout-row gap-xl">
              <div class="flex layout-col">
                <!-- Identifications -->
                <elder-pane-subtitle>{{
                  'context.identification' | translate
                }}</elder-pane-subtitle>
                <div class="layout-col gap-md">
                  <!-- label input field -->
                  <mat-form-field class="flex">
                    <mat-label>{{ 'production_codes.label' | translate }}</mat-label>
                    <input
                      matInput
                      name="label"
                      placeholder="{{ 'production_codes.label' | translate }}"
                      [(ngModel)]="prodCode.label"
                    />
                  </mat-form-field>
                  <!-- code input field -->
                  <mat-form-field class="flex">
                    <mat-label>{{ 'production_codes.code' | translate }}</mat-label>
                    <input
                      matInput
                      name="code"
                      placeholder="{{ 'production_codes.code' | translate }}"
                      [(ngModel)]="prodCode.code"
                    />
                  </mat-form-field>
                  <!-- default message input field -->
                  <mat-form-field class="flex">
                    <mat-label>{{ 'production_codes.default_message' | translate }}</mat-label>
                    <input
                      matInput
                      name="description"
                      placeholder="{{ 'production_codes.default_message' | translate }}"
                      [(ngModel)]="prodCode.defaultMessage"
                    />
                  </mat-form-field>
                </div>
              </div>
            </form>
          </elder-pane-content>
        </elder-pane>
      </elder-basic-pane-layout>
    </div>
  </div>
}

<ng-template #header let-prodCode>
  @if (creationMode) {
    <span>
      {{ 'production-codes.new' | translate }}
    </span>
  } @else {
    <elder-header [header]="'production_codes.code' | translate" [subheader]="'ID: ' + prodCode.id">
    </elder-header>
  }
</ng-template>
